// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component, useEffect } from 'react';
import { SanitizedHTML } from 'components/atoms';

let captcha_value = '';
let captcha_number = '';
let backgroundColor_value = '';
let fontColor_value = '';
let charMap_value = '';
let LoadCanvasTemplate_HTML =
  '<div><canvas id="canv"></canvas><div><a id="reload_href"  style="cursor: pointer; color: blue">Reload Captcha</a></div></div>';
const LoadCanvasTemplateNoReload_HTML =
  '<div><canvas id="canv"></canvas><div><a id="reload_href"  style="cursor: pointer; color: blue"></a></div></div>';

export const loadCaptchaEngine = (
  numberOfCharacters,
  backgroundColor = 'white',
  fontColor = 'black',
  charMap = ''
) => {
  backgroundColor_value = backgroundColor;
  fontColor_value = fontColor;
  charMap_value = charMap;
  captcha_number = numberOfCharacters;
  let retVal = '';
  let charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  if (charMap === 'upper') {
    charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  } else if (charMap === 'lower') {
    charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  } else if (charMap === 'numbers') {
    charset = '0123456789';
  } else if (charMap === 'special_char') {
    charset = "~`!@#$%^&*()_+-=[]{}|:'<>,.?/";
  }

  const length = parseInt(numberOfCharacters);

  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }

  const captcha = retVal;

  captcha_value = captcha;

  const length_height_canvas = Math.round(parseInt(length) / 3);

  const canvas = document.getElementById('canv'),
    ctx = canvas.getContext('2d'),
    img = document.getElementById('image');
  const text = captcha;
  const x = 12.5;
  const y = 15;
  const lineheight = 30;

  const canvas_height = (parseInt(length) - parseInt(length_height_canvas)) * 20;
  const lines = text.split('\n');
  const lineLengthOrder = lines.slice(0).sort(function (a, b) {
    return b.length - a.length;
  });
  ctx.canvas.width = parseInt(length) * 25;
  ctx.canvas.height = lines.length * lineheight;

  ctx.fillStyle = backgroundColor;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.textBaseline = 'middle';
  ctx.font = 'italic 20px Arial';
  ctx.fillStyle = fontColor;

  let num = 0;
  for (let i = 0; i < parseInt(length); i++) {
    num = parseInt(num) + 1;
    const heigt_num = 20 * num;
    ctx.fillText(retVal[i], heigt_num, Math.round(Math.random() * (15 - 12) + 12));
  }

  document.getElementById('reload_href').onclick = function () {
    loadCaptchaEngine(captcha_number, backgroundColor, fontColor, charMap);
  };
};

export const validateCaptcha = (userValue, reload = true) => {
  if (userValue != captcha_value) {
    if (reload == true) {
      loadCaptchaEngine(captcha_number, backgroundColor_value, fontColor_value, charMap_value);
    }

    return false;
  } else {
    return true;
  }
};

export class LoadCanvasTemplate extends Component {
  render() {
    let reload_text = '';
    let reload_color = '';
    LoadCanvasTemplate_HTML =
      '<div><canvas id="canv" style="background-color: blue;"></canvas><div><a id="reload_href"  style="cursor: pointer; color: blue">Reload Captcha</a></div></div>';

    if (this.props.reloadText) {
      reload_text = this.props.reloadText;
    }

    if (this.props.reloadColor) {
      reload_color = this.props.reloadColor;
    }

    if (reload_text == '') {
      reload_text = 'Reload Captcha';
    }

    if (reload_color == '') {
      reload_color = 'blue';
    }

    LoadCanvasTemplate_HTML =
      '<div><canvas id="canv"></canvas><div><a id="reload_href"  style="cursor: pointer; color: ' +
      reload_color +
      '">' +
      reload_text +
      '</a></div></div>';

    return <SanitizedHTML dirtyHTML={LoadCanvasTemplate_HTML} />;
  }
}

export class LoadCanvasTemplateNoReload extends Component {
  render() {
    return <SanitizedHTML dirtyHTML={LoadCanvasTemplateNoReload_HTML} />;
  }
}

export function SecurityCode(props, ref) {
  useEffect(() => {
    loadCaptchaEngine(5, '#fff', '#000', 'numbers');
  }, []);

  return (
    <div className="mt-5 w-full">
      <div className="flex w-full flex-row items-center justify-between">
        <label className="mb-2 block text-body16 text-neutral-800">{props.label}</label>
        {props.error && (
          <span className="text-danger" style={{ fontSize: 11 }}>
            {props.error}
          </span>
        )}
      </div>
      <div className="flex flex-col justify-center gap-4 [text-align-last:center] xs:flex-row xs:items-center">
        <div className="flex min-h-[3.5rem] flex-1 items-center justify-center rounded-md border border-primary-100 shadow-md">
          <LoadCanvasTemplateNoReload />
        </div>
        <div className="flex h-full items-center justify-center">
          <img
            src={new URL('assets/svg/refresh.svg', import.meta.url).href}
            alt="refresh icon"
            onClick={() => {
              loadCaptchaEngine(5, '#fff', '#000', 'numbers');
            }}
            className="hover-transition h-8 w-8 shrink-0"
          />
        </div>
        <div className="flex-1">
          <input
            className={`block min-h-[3.5rem] w-full rounded-md border px-4 text-label20 shadow-md focus:bg-primary-0 focus:outline-none ${
              props.error ? 'border-danger' : 'border-primary-100'
            }`}
            type="text"
            ref={props.innerRef}
            name={props.name}
            onBlur={props.onBlur}
            value={props.value}
            maxLength={props?.maxLength ?? 5}
            onChange={props.onChange}
            placeholder={props.label}
          />
        </div>
      </div>
    </div>
  );
}
